import styled from 'styled-components';

import { COLORS } from 'theme';

export const LabeledContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  gap: ${({ theme }) => theme.spacing.s3};
`;

export const Content = styled.span`
  font-size: ${({ theme }) => theme.fontSize.body2};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: ${({ theme }) => theme.lineHeight.body2};
  color: inherit;
`;

export const Label = styled.span`
  font-size: ${({ theme }) => theme.fontSize.h6};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  line-height: ${({ theme }) => theme.lineHeight.h6};
  color: ${COLORS.black40};
  text-align: right;
  white-space: nowrap;
`;
